import React from 'react'
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles'
import { Card, CardContent, Box, Grid } from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: 'relative',
      minWidth: 180,
      height: '100%'
    },
    container: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: theme.spacing(4)
    },
    title: {
      fontSize: '12pt',
      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
      color: '#4B4B4B',
      fontWeight: 400
    },
    data: {
      display: 'flex',
      marginTop: '40px',
      justifyContent: 'space-between'
    }
  })
)

export default function ChartDonutSkeleton (): JSX.Element {
  const classes = useStyles()

  return (
    <Card className={classes.root}>
      <Grid container className={classes.container}>
        <CardContent>
          <Box>
            <Skeleton width="60%" height={32} />
          </Box>
          <Box className={classes.data}>
            <Box>
              <Skeleton variant="circle" height={220} width={220} />
            </Box>
            <Box>
              <Skeleton height={20} width={160} />
              <Skeleton height={20} width={120} />
              <Skeleton height={20} width={90} />
            </Box>
          </Box>
        </CardContent>
      </Grid>
    </Card>
  )
}
